/** Hide the initial HTML splash loader (shown on hard refresh). */
export const hideAppLoader = () => {
  try {
    window.__WLJ_APP_READY__ = true;
    if (typeof window.__WLJ_REVEAL_APP__ === "function") {
      window.__WLJ_REVEAL_APP__();
    }
  } catch (e) {
    // ignore
  }
};
